module.exports = __webpack_public_path__ + "static/media/expo.f49ee584.png";